export function pickWeighted<T>(
  items: { item: T; probability: number }[],
  probabilitySum = Math.random(),
): T | undefined {
  return (
    items.find((b) => (probabilitySum -= b.probability) < 0) || items.pop()
  )?.item;
}
